import React, { createContext, useContext, useMemo, useState } from 'react';
import {
  IS_ACTIVE_PRIME_USER,
  usePriceFreezeSession,
} from '@/hooks/usePriceFreezeSession';
import { useMembershipAccountPropertiesQuery } from '@/hooks/GQL';
import { useLogin } from '@/providers/login/LoginProvider';

const isActivePrimeMember = (userEmail, data, isActiveSessionData) => {
  let isActive;
  if (userEmail) {
    isActive = data?.membershipAccountProperties?.isActive ?? false;
  } else {
    isActive = isActiveSessionData;
  }
  return isActive;
};

const IsActivePrimeUserContext = createContext(null);

export const PrimeUserProvider = ({ children }) => {
  const { isLogged } = useLogin();
  const [userEmail, setUserEmail] = useState('');
  const { data, loading, errors } = useMembershipAccountPropertiesQuery({
    userEmail,
    isLogged,
  });
  const [getSessionItem] = usePriceFreezeSession();
  const getIsActiveSessionData = getSessionItem(IS_ACTIVE_PRIME_USER);
  const isActiveSessionData =
    getIsActiveSessionData != null ? getIsActiveSessionData : false;

  const isActive = isActivePrimeMember(userEmail, data, isActiveSessionData);

  const values = useMemo(() => {
    return {
      userEmail,
      setUserEmail,
      isActive,
      loading,
      errors,
    };
  }, [userEmail, isActive, loading, errors]);

  return (
    <IsActivePrimeUserContext.Provider value={values}>
      {children}
    </IsActivePrimeUserContext.Provider>
  );
};

export const useIsActivePrimeUser = () => {
  const context = useContext(IsActivePrimeUserContext);
  return context;
};
